import React, {useState} from 'react';
import PropTypes from 'prop-types';
import '../styles/client-member-list.css';
import {memberSupportsClient, tabButtonStyles} from 'utils/General';
import ConnectedMembers from "./ConnectedMembers";
import NotConnectedMembers from "./NotConnectedMembers";
import Translate from "../../../../../components/Translate";

const ClientMemberList = ({
                              members,
                              client,
                              addMembersToClient,
                              removeMembersFromClient,
                              skills,
                              user,
                              tariff
                          }) => {

    const [activeTab, setActiveTab] = useState('connectedMembers');

    const connectedMembers = members.filter((member) => memberSupportsClient(member, client));
    const notConnectedMembers = members.filter((member) => !memberSupportsClient(member, client));

    return (
        <React.Fragment>

            <div style={tabButtonStyles.tabButtons}>
                <button style={tabButtonStyles.tabButton(activeTab === 'connectedMembers')}
                        onClick={() => setActiveTab('connectedMembers')}>
                    <Translate text="connectedMembers"/> ({connectedMembers.length})
                </button>
                <button style={tabButtonStyles.tabButton(activeTab === 'notConnectedMembers')}
                        onClick={() => setActiveTab('notConnectedMembers')}>
                    <Translate text="notConnectedMembers"/> ({notConnectedMembers.length})
                </button>
            </div>

            <div className="bg-white">

                {activeTab === 'connectedMembers' && (
                    <div>
                        <ConnectedMembers tariff={tariff} user={user} skills={skills} client={client}
                                          connectedMembers={connectedMembers}
                                          removeMembersFromClient={removeMembersFromClient}/>
                    </div>
                )}

                {activeTab === 'notConnectedMembers' && (
                    <div>
                        <NotConnectedMembers client={client} notConnectedMembers={notConnectedMembers}
                                             addMembersToClient={addMembersToClient}/>
                    </div>
                )}

            </div>
        </React.Fragment>
    );
};

ClientMemberList.propTypes = {
    members: PropTypes.array.isRequired,
    client: PropTypes.object.isRequired,
    addMembersToClient: PropTypes.func.isRequired,
    removeMembersFromClient: PropTypes.func.isRequired,
    skills: PropTypes.array,
    user: PropTypes.object,
    tariff: PropTypes.object
};

export default ClientMemberList;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/ClientMemberList.jsx